import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { RevokeUserImpersonation } from '../../shared/states/user.actions';
import { isImpersonationDeniedError } from './impersonation-denied';

@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  private readonly auth = inject(AuthService);
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const impersonatedUser = this.auth.impersonatedUser();
    if (impersonatedUser && !req.url.includes('scd.suites')) {
      req = req.clone({
        setHeaders: {
          'X-Impersonate': impersonatedUser + '',
        },
      });
    }
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        // Guard on the current state so parallel failing requests revoke only once
        if (isImpersonationDeniedError(error) && this.auth.impersonatedUser()) {
          this.store.dispatch(new RevokeUserImpersonation());
          void this.router.navigate(['/home']);
        }
        return throwError(() => error);
      }),
    );
  }
}
